var PatentImageServiceImpl_1;
var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import { QueryPatentImagesService } from './query-patent-images-service.interface';
let PatentImageServiceImpl = class PatentImageServiceImpl extends AbstractModel {
    static { PatentImageServiceImpl_1 = this; }
    constructor(_queryPatentImagesService) {
        super();
        this._queryPatentImagesService = _queryPatentImagesService;
        this._modelData = {
            totalImageCount: 0,
            startIndex: -1,
            currentImageIndex: -1,
            loading: false,
            error: false,
            patentId: '',
            currentImageUrl: '',
            hasPreviousImage: false,
            hasNextImage: false,
        };
        this._images = new Map();
        this._patentId = '';
    }
    static { this.PAGE_SIZE = 20; }
    insertImageBefore(image) {
        this._insertImage = image;
        this.update((data) => {
            data.startIndex = -2;
            data.currentImageIndex = -2;
            data.currentImageUrl = image;
            return data;
        });
        this._setImageCacheByIndex(-1, {
            imageId: 'insert-image-before',
            imageUrl: image,
            patentId: this.patentId,
        });
    }
    _setImageCacheByIndex(index, image) {
        this._images.set(index, image);
    }
    get currentImageIndex() {
        return this.modelData.currentImageIndex;
    }
    get totalImageCount() {
        return this.modelData.totalImageCount;
    }
    get loading() {
        return this.modelData.loading;
    }
    previousImage() {
        let currentImageIndex = this.currentImageIndex;
        if (currentImageIndex <= (this.modelData.startIndex + 1) || this.loading) {
            return;
        }
        return this._getPatentImageByIndex(--currentImageIndex);
    }
    nextImage() {
        let currentImageIndex = this.currentImageIndex;
        if (currentImageIndex >= this.totalImageCount - 1 || this.loading) {
            return;
        }
        return this._getPatentImageByIndex(++currentImageIndex);
    }
    get patentId() {
        return this._patentId;
    }
    async loadPatentImages(patentId) {
        this._patentId = patentId;
        this.update((data) => {
            data.patentId = patentId;
            data.loading = true;
            return data;
        });
        const { total, images } = await this._queryPatentImagesService.queryPatentImages({
            patentId,
            page: 1,
            pageSize: PatentImageServiceImpl_1.PAGE_SIZE,
        });
        images.forEach((image, index) => {
            this._setImageCacheByIndex(index, image);
        });
        const totalImageCount = total + (this._insertImage ? 1 : 0);
        this.update((data) => {
            data.loading = false;
            data.totalImageCount = totalImageCount;
            return data;
        });
        return totalImageCount;
    }
    async _getPatentImageByIndex(index) {
        const imageUrl = this._images.get(index)?.imageUrl;
        if (imageUrl) {
            this.update((data) => {
                data.loading = false;
                data.currentImageUrl = imageUrl;
                data.currentImageIndex = index;
                data.hasPreviousImage = index > data.startIndex + 1;
                data.hasNextImage = index < data.totalImageCount + data.startIndex;
                return data;
            });
            return;
        }
        this.update((data) => {
            data.loading = true;
            data.currentImageUrl = '';
            return data;
        });
        const page = this._getCurrentPageByIndex(index);
        const { images } = await this._queryPatentImagesService.queryPatentImages({
            patentId: this.patentId,
            page,
            pageSize: PatentImageServiceImpl_1.PAGE_SIZE,
        });
        images.forEach((image, index) => {
            const uIndex = (page - 1) * PatentImageServiceImpl_1.PAGE_SIZE + index;
            this._setImageCacheByIndex(uIndex, image);
        });
        return this._getPatentImageByIndex(index);
    }
    _getCurrentPageByIndex(index) {
        const pageSize = PatentImageServiceImpl_1.PAGE_SIZE;
        const page = Math.floor(index / pageSize) + 1;
        return page;
    }
};
PatentImageServiceImpl = PatentImageServiceImpl_1 = __decorate([
    injectable(),
    __param(0, inject(QueryPatentImagesService)),
    __metadata("design:paramtypes", [typeof (_a = typeof QueryPatentImagesService !== "undefined" && QueryPatentImagesService) === "function" ? _a : Object])
], PatentImageServiceImpl);
export { PatentImageServiceImpl };
